import { Permissions } from '../../../reducers/root.reducer';

export const payrollPermissions: Permissions = [
  'ViewPayrollHoliday',
  'EditPayrollHoliday',
  'EditPayrollRota',
  'ViewPayrollRota',
  'ViewPayrollReports',
] as Permissions;
